module.exports = __webpack_public_path__ + "fonts/10709a93a20fb64479009d81b66feda6.svg";